module.exports = __webpack_public_path__ + "resources/img/img_secure_center02_m.b8b3faa7837c52effacacbc296531292.png";